import React from 'react';


export class Input extends React.Component {
    render() {
        const {
            color = 'main',
            value= '',
            placeholder= '',
            type= 'text',
            height= 'auto',
            onChange = (event) => {},
            onKeyDown = (event) => {},
            onBlur = (event) => {}
        } = this.props;
        
        return (
            <input
                className={'imd-form-control imd-text-' + color}
                type={type}
                style={{height: height}}
                value={value}
                placeholder={placeholder}
                onChange={(event) => onChange(event)}
                onKeyDown={(event) => onKeyDown(event)}
                onBlur={(event) => onBlur(event)}
            />
        );
    }
}
